<template>
  <!--文章列表 -->
  <div class="container">
    <div class="vue">
      <div class="header flex flexAi-c">
        <div class="text primaryCol">文章列表</div>
        <el-button
          class="butSmallH"
          @click="addArticleBut"
          type="primary"
          size="small"
          >添加文章</el-button
        >
      </div>
      <div class="contant">
        <div class="table-head padVertical10 flex flexJc-fe flexAi-c">
          <div class="head-title flex  flexAi-c">
            <span>所属栏目 :</span>
            <el-cascader
              class="padHorizontal10"
              size="small"
              v-model="form.cascader"
              :props="{ value: 'id', label: 'name', children: 'list' }"
              :options="cascaderOptions"
              clearable
              @visible-change="cascaderVisibleChange"
              @change="cascaderChange"
            ></el-cascader>
          </div>
          <!-- <el-button @click="searchClick" size="small" type="primary"
            >搜索</el-button
          > -->
        </div>
        <el-table height="70vh" :data="ArticleData.list" style="width: 100%">
          <el-table-column label="ID" width="60">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | FilterDataTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="标题"> </el-table-column>
          <el-table-column label="文章图片">
            <template slot-scope="scope">
              <el-image
                style="height:80px;width:50%"
                :src="scope.row.thumbnail"
                fit="scale-down"
              ></el-image>
              <!-- <span>{{
                 | FilterNumber('一级栏目', '二级栏目')
              }}</span> -->
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small"
                >编辑</el-button
              >
              <el-popover
                class="padHorizontal10"
                placement="top"
                width="180"
                :ref="`popover-${scope.$index}`"
              >
                <p>这是一段内容这是一段内容确定删除吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    size="mini"
                    type="text"
                    @click="
                      scope._self.$refs[`popover-${scope.$index}`].doClose()
                    "
                    >取消</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="
                      cancelClick(
                        scope.row,
                        scope._self.$refs[`popover-${scope.$index}`].doClose()
                      )
                    "
                    >确定</el-button
                  >
                </div>
                <el-button slot="reference" type="text" size="small"
                  >删除</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="block" v-if="ArticleData.list != null">
        <el-pagination
          background
          :current-page="page"
          :page-size="ArticleData.pageSize"
          layout="prev, pager, next, jumper"
          :total="ArticleData.total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// 导入我们的api接口
import {
  apiArticleFindAll,
  apiDelArticle,
  apiNavigationFindAll
} from '@/api/backgroundViews'

export default {
  name: '',
  props: [''],
  data() {
    return {
      page: 1, // 当前页数
      size: 10,
      form: {
        cascader: ''
      },
      cascaderOptions: [], // 搜索栏目
      ArticleData: '', // 文章内容
      cancelVisible: false // 删除弹出框
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.ArticleFindAlll()
  },

  methods: {
    /* 搜索 */

    // 下拉框当选中节点变化时触发
    cascaderChange() {
      this.ArticleFindAlll()
    },
    // 下拉框出现/隐藏时触发
    cascaderVisibleChange(e) {
      if (e) {
        this.NavigationFindAll()
      }
    },
    // 搜索
    searchClick() {
      if (!this.form.cascader) {
        this.$Me('所属栏目不能为空')
        return
      }
      this.ArticleFindAlll()
    },
    // 分页
    handleCurrentChange(e) {
      this.page = e
      this.ArticleFindAlll()
      console.log(`当前页: ${e}`)
    },
    // 添加文章
    addArticleBut() {
      this.$router.push({
        path: '/addArticle'
      })
    },
    // 列表编辑
    editClick(row) {
      console.log(row)
      this.$router.push({
        path: '/addArticle',
        query: {
          id: row.id,
          name: row.name,
          type: row.type,
          text: row.text,
          thumbnail: row.thumbnail
        }
      })
    },
    // 列表删除
    cancelClick(row) {
      apiDelArticle({
        id: row.id
      }).then(res => {
        if (res.status === '0') {
          this.$Ms(res.msg)
          if (this.ArticleData.size === 1 && this.ArticleData.pages !== 1) {
            this.page--
          }
          this.ArticleFindAlll()
        } else if (res.status === '1') {
          this.$Me(res.msg)
        }
      })
    },
    /*
     *接口
     */
    // 查询全部文章
    ArticleFindAlll() {
      let newType
      console.log(this.form.cascader.length)
      if (this.form.cascader.length === 1) {
        newType = this.form.cascader[0]
      } else if (this.form.cascader.length > 1) {
        newType = this.form.cascader[this.form.cascader.length - 1]
      }
      apiArticleFindAll({
        page: this.page,
        size: this.size,
        type: newType
      }).then(res => {
        if (res.status === '0') {
          this.ArticleData = res.data
        }
      })
    },
    // 查询全部导航栏
    NavigationFindAll() {
      apiNavigationFindAll({
        status: 0
      }).then(res => {
        this.cascaderOptions = res.data
        this.$forceUpdate()
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
$padding: 10px;
$colorMajor: #005ca1;
.vue {
  text-align: left;
  background-color: #fff;
  padding: $padding;
  .header {
    border-bottom: 1px solid #f3f3f3;
    justify-content: space-between;
    .text {
      text-align: left;
      padding: 10px 5px;
    }
  }
  .contant {
    .table-head {
    }
  }
  .but {
    padding-bottom: $padding - 2px;
  }
  .block {
    text-align: right;
    padding: 10px 20px;
  }
}
</style>
